import { createOverflowLabelViewDriver } from '../../new-libby/core/overflow-labels-view/driver';
import { compKey } from './key';
export var createlabelListDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    var getLabelByIdx = function (idx) { return base.$$('.label-list-item').get(idx); };
    return {
        getTitle: function () { return base.$('.label-list-title').text(); },
        getLabelTexts: function () { return base.$$('.label-text').text(); },
        clickLabel: function (idx) { return getLabelByIdx(idx).click(); },
        showMoreLabelExist: function () { return base.$('.show-more-label').exists(); },
        overflowLabelViewDriver: createOverflowLabelViewDriver(base),
        base: base,
    };
};
//# sourceMappingURL=driver.js.map